import React from 'react'

function Loading() {
    return (
        <>
        <div className="loading">
            <div className="loading__symbol"></div>
        </div>
        </>
    )
}

export default Loading